import './rollbar';
import "@hotwired/turbo-rails";
import "@37signals/lexxy";
import "./controllers";
import * as bootstrap from "bootstrap";

// Preserve scroll position when turbo frames are updated via form submissions
let frameScrollY = null;

document.addEventListener("turbo:submit-start", (event) => {
  if (event.target.closest("turbo-frame")) {
    frameScrollY = window.scrollY;
  }
});

document.addEventListener("turbo:frame-render", () => {
  if (frameScrollY !== null) {
    window.scrollTo(0, frameScrollY);
    frameScrollY = null;
  }
});

// Initialize Bootstrap tooltips after Turbo navigation (also fires on initial page load)
document.addEventListener("turbo:load", () => {
  document
    .querySelectorAll('[data-bs-toggle="tooltip"]')
    .forEach((el) => new bootstrap.Tooltip(el));

  // Ensure mobile nav collapses when resizing up to desktop widths.
  const collapseEl = document.getElementById("siteNavbar");
  if (collapseEl) {
    const bsCollapse = bootstrap.Collapse.getOrCreateInstance(collapseEl, {
      toggle: false,
    });

    const maybeClose = () => {
      if (window.innerWidth >= 992) {
        bsCollapse.hide();
      }
    };

    window.addEventListener("resize", maybeClose);
    maybeClose();
  }
});
